const filtersTextChange = (str) => {
    if(str !=null){
        let value = str.replace(/<\/?.+?>/g,"").replace(/ /g,"");
        return value;
    }
    
}

const formatDate  = (val) => {
   if(val !=null){
       let  time = val.split(" ")[0];
       return time;
   }
}
export{
    filtersTextChange,
    formatDate
}


// WEBPACK FOOTER //
// ./src/util/filters.js